import { defineAction, number, object, string } from '~/prix'
import llmChatCreateAction from './llmChatCreate.action.json' with { type: 'json' }

const llmChatCreateDefinition = defineAction({
  ...llmChatCreateAction,

  input: object({
    title: string().isOptional(),
  }),
  output: object({
    id: number(),
    title: string().isOptional(),
    createdAt: string(),
  }),
})

export default llmChatCreateDefinition
